import React from 'react';
import ReactTooltip from 'react-tooltip';
import { useSelector } from 'react-redux';
import styles from './Name.module.scss';
import { LANGUAGES } from '../../../../../../constants/defaultValues';
import useGoalBadge from '../../../../../../hooks/useGoalBadge';
import RedCardBadge from './RedCardBadge/RedCardBadge';
import GoalBadge from './GoalBadge/GoalBadge';

const Name = ({ eventId, league, teams, categoryName, liveStatistics }) => {
    const { locale, theme } = useSelector(state => state.settings);

    const showHomeGoalBadge = useGoalBadge(liveStatistics?.homeTeamScore);
    const showAwayGoalBadge = useGoalBadge(liveStatistics?.awayTeamScore);

    return (
        <>
            <ReactTooltip
                id={eventId}
                place='top'
                type={theme ? 'dark' : 'light'}
                aria-haspopup='true'
                className={styles.eventNameTooltip}
            >
                <p>{categoryName}</p>
                <p>{league}</p>
                <p>{teams.home[locale] || teams.home[LANGUAGES.eng]}</p>
                <p>{teams.away[locale] || teams.away[LANGUAGES.eng]}</p>
            </ReactTooltip>
            <div className={styles.nameContainer}>
                <span className={styles.name}>{teams.home[locale] || teams.home[LANGUAGES.eng]}</span>
                <RedCardBadge redCards={liveStatistics?.homeTeamRedCards} />
                {showHomeGoalBadge && <GoalBadge />}
            </div>
            <div className={styles.nameContainer}>
                <span className={styles.name}>{teams.away[locale] || teams.away[LANGUAGES.eng]}</span>
                <RedCardBadge redCards={liveStatistics?.awayTeamRedCards} />
                {showAwayGoalBadge && <GoalBadge />}
            </div>
        </>
    );
};

export default Name;
